export default "__VITE_ASSET__D1ofqfiL__"